const type = 'SET_PAY_STATEMENT_LOADING';

const setPayStatementLoading = (data) => ({
  data,
  type,
});

export { type };
export default setPayStatementLoading;
